import { Update } from "../components/individual-counseling-project-contents-register/Update";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/**
 個別相談案件相談内容更新画面
 */
const IndividualCounselingProjectContentsUpdate = () => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.INDIVIDUAL_COUNSELING);

  return (
    <SpaceBetween size="l">
      <Update />
    </SpaceBetween>
  );
};

export default IndividualCounselingProjectContentsUpdate;
